let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("17m16"), load("cMubu"), load("kAg8V"), load("6z8G9")]).then(() => parcelRequire('1Lu20'));